import Leitsystem from "@/pages/Leitsystem/Leitsystem.vue";

export default [
  {
    path: "/leitsystem",
    name: "leitsystem",
    component: Leitsystem,
  },
];
